import apiClient from "./http";

export const getDirections = (payload = {}) =>
  apiClient.post("/Vastu/analyze-property", payload);

export const updateDirections = (payload) =>
  apiClient.post("/Dashboard/log-event", {
    event: "directions_update",
    source: "ui",
    ts: new Date().toISOString(),
  });
